import React, { useEffect, useState } from 'react';
import { Modal, Typography } from '@mui/material';
import {
  FlexColumn,
  FlexRow,
  ModalContentWrapper,
  PrimaryActionButton,
  SecondaryActionButton,
  StyledBox,
  StyledTextField,
} from './styled';

export default function PasswordConfirmationModal({
  open, onClose, onConfirm,
}) {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (!open) {
      setPassword('');
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(password);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="password-modal-title"
      aria-describedby="password-modal-description"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(30, 33, 41, 0.8675)',
          },
        },
      }}
    >
      <ModalContentWrapper>
        <StyledBox>
          <FlexColumn sx={{ gap: 2, alignItems: 'center', width: '100%' }}>
            <FlexColumn sx={{ gap: 0.5, alignItems: 'center', width: '100%' }}>
              <Typography id="password-modal-title" variant="h5" component="h2">
                Enter Your Password
              </Typography>
              <Typography id="password-modal-description" sx={{ textAlign: 'center' }}>
                For your security, please enter your password to confirm.
              </Typography>
            </FlexColumn>
            <StyledTextField
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              sx={{ mt: 2 }}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && password && handleConfirm()}
            />
          </FlexColumn>
          <FlexRow sx={{ gap: 2, mt: 3 }}>
            <SecondaryActionButton
              variant="text"
              onClick={onClose}
            >
              Cancel
            </SecondaryActionButton>
            <PrimaryActionButton
              variant="outlined"
              onClick={handleConfirm}
              disabled={!password}
            >
              Confirm
            </PrimaryActionButton>
          </FlexRow>
        </StyledBox>
      </ModalContentWrapper>
    </Modal>
  );
}
